import BASE_URL from "../config/apiConfig";

export const TenantRentService = {
  // Function to get the auth token from session storage
  getAuthToken() {
    return sessionStorage.getItem("jwt");
  },

  async fetchTenantPaymentHistory() {
    const token = this.getAuthToken();
    try {
      const response = await fetch(`${BASE_URL}TenantRentPayment`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch tenants payments");
      }

      return await response.json();
    } catch (error) {
      console.error("Error fetching tenants payments:", error);
      throw error;
    }
  },
  async FetchFinanceDataForCurrentMonth() {
    const token = this.getAuthToken();
    try {
      const response = await fetch(
        `${BASE_URL}TenantRentPayment/GetFinanceDataForCurrentMonth`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch tenants payments");
      }

      return await response.json();
    } catch (error) {
      console.error("Error fetching tenants payments:", error);
      throw error;
    }
  },

  // Add Rent Payment
  async addRentPaymentFromTenant(tenantRentPayment: any) {
    const token = this.getAuthToken();
    try {
      const response = await fetch(
        `${BASE_URL}TenantRentPayment/AddTenantRentPayment`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
          },
          body: JSON.stringify(tenantRentPayment),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to create/update tenant");
      }

      return await response.json();
    } catch (error) {
      console.error("Error posting tenant:", error);
      throw error;
    }
  },
};
